import TableDataType = ToroSaEnums.TableDataType;

import * as moment from 'moment';
import { ToroSaEnums } from '../../../spatial-adjust/enums/spatial-adjust.enums';

export class SaVwcHistoryRequest {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            if (json.startDate) this.startDate = moment.utc(json.startDate).startOf('day').toDate();
            if (json.endDate) this.endDate = moment.utc(json.endDate).startOf('day').toDate();
        }
    }

    type: TableDataType;
    orgId: number;
    turfRadCourseId: number;
    entityInfos: { id: string, name: string }[];
    startDate: Date;
    endDate: Date;
}
